import {
  HYBRID_CODE_SERVICE_FEATURE_FLAG,
  INTERNAL_NETWORK_PENTEST_FEATURE_FLAG,
  PERMISSION_DEFINITIONS,
  ROLE_DEFINITIONS,
  ROLES,
  type AuthFeatureFlagKey,
  type Permission,
  type RoleDefinition,
} from './permissions';

export {
  HYBRID_CODE_SERVICE_FEATURE_FLAG,
  INTERNAL_NETWORK_PENTEST_FEATURE_FLAG,
};

export type PermissionDefinitionForSync = {
  name: Permission;
  description: string;
  featureFlagKey?: AuthFeatureFlagKey;
};

export const FEATURE_FLAG_GATED_AUTH_FLAG_KEYS = [
  INTERNAL_NETWORK_PENTEST_FEATURE_FLAG,
  HYBRID_CODE_SERVICE_FEATURE_FLAG,
] as const;

export type FeatureFlagGatedAuthFlagKey =
  (typeof FEATURE_FLAG_GATED_AUTH_FLAG_KEYS)[number];

export const isAuthInfraEnabledForFlag = ({
  featureFlagKey,
  enabledFeatureFlags,
}: {
  featureFlagKey: string | undefined;
  enabledFeatureFlags: ReadonlySet<string>;
}): boolean => {
  if (!featureFlagKey) {
    return true;
  }

  return enabledFeatureFlags.has(featureFlagKey);
};

export const resolvePermissionDefinitionsForSync = ({
  enabledFeatureFlags,
}: {
  enabledFeatureFlags: ReadonlySet<string>;
}): PermissionDefinitionForSync[] =>
  PERMISSION_DEFINITIONS.filter((definition) =>
    isAuthInfraEnabledForFlag({
      featureFlagKey: definition.featureFlagKey,
      enabledFeatureFlags,
    }),
  );

export const resolveRoleDefinitionsForSync = ({
  enabledFeatureFlags,
}: {
  enabledFeatureFlags: ReadonlySet<string>;
}): RoleDefinition[] =>
  ROLE_DEFINITIONS.filter((definition) =>
    isAuthInfraEnabledForFlag({
      featureFlagKey: definition.featureFlagKey,
      enabledFeatureFlags,
    }),
  ).map((definition) => {
    if (definition.name !== ROLES.TENANT_ADMIN) {
      return definition;
    }

    return {
      ...definition,
      permissions: definition.permissions.filter((permissionName) => {
        const permissionDefinition = PERMISSION_DEFINITIONS.find(
          (entry) => entry.name === permissionName,
        );

        return isAuthInfraEnabledForFlag({
          featureFlagKey: permissionDefinition?.featureFlagKey,
          enabledFeatureFlags,
        });
      }),
    };
  });
